import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login'
import MainContainer from '../components/MainContainer'
import PiTransit from '../components/PiTransit'
import OtvtOrganizations from '../components/OtvtOrganizations'
import PageNotFound from '../components/PageNotFound'
import { store } from '../store/index'

Vue.use(VueRouter)

const ifAuthenticated = (to, from, next) => {
  if (store.getters['authorization/isAuthenticated']) {
    next()
    return
  }
  next('/login')
}

const routes = [
  {
    path: '/',
    name: 'MainContainer',
    component: MainContainer,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: 'pi-transit',
        name: 'PiTransit',
        component: PiTransit,
        meta: { name: 'ПИ и Транзит' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/otvt-groups-users',
        component: OtvtOrganizations,
        name: 'otvt-groups-users',
        meta: { name: 'Организации ОТВТ' },
        beforeEnter: ifAuthenticated
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '*', component: PageNotFound
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
